<div class="p-t-sm">
  <div class="box card-box m-x-sm shadow">
    <div class="box-header">
      <h3>{{ 'MENU.PROCESS_MONITOR' | translate }}</h3>
    </div>
    <div class="box-tool">
      <button class="btn btn-xs btn-outline-primary" (click)="toggleCharts()"
              [disabled]="!requests?.length">
        <em class="fa fa-l fa-chart-pie-simple"></em>
        <span class="m-l-xs">{{ (showCharts ? 'Onboarding.hide_charts' : 'Onboarding.show_charts') | translate }}</span>
      </button>
      <button (click)="resetFilters()"
              [disabled]="!filterFormGroup.dirty"
              class="m-l-xs btn btn-xs btn-outline-primary"
              test-id="clear-all-filters"
              type="button">
        <em class="fa fa-light fa-filter-circle-xmark"></em>
        <span class="m-l-xs">{{'CONTEXT_BAR.clear_all_filters' | translate}}</span>
      </button>
    </div>
    <div class="box-body" #tableScrollContainer [formGroup]="filterFormGroup">
      <div class="mb-3 chart-container-wrapper" *ngIf="showCharts">
        <div *ngIf="workflowTypes?.length > 0 &&  workflowByTypeChartConfig" class="chart-flex-item">
          <gp-echart
            [height]="'250px'"
            [width]="'90%'"
            [options]="workflowByTypeChartConfig"
            (datumClick)="onTypeClick($event)"
          >
          </gp-echart>
        </div>
        <div *ngIf="workflowTypes?.length > 0 && workflowByStatusChartConfig" class="chart-flex-item">
          <gp-echart
            [height]="'250px'"
            [width]="'100%'"
            [options]="workflowByStatusChartConfig"
            (datumClick)="onStatusClick($event)"
          >
          </gp-echart>
        </div>
        <div *ngIf="workflowTypes?.length > 0 && oldWorkflowChartConfig" class="chart-flex-item">
          <gp-echart
            [height]="'250px'"
            [width]="'90%'"
            [options]="oldWorkflowChartConfig"
            (datumClick)="onOldWorkflowsClick($event)"
          >
          </gp-echart>
        </div>
      </div>
      <table aria-describedby="workflow-table" class="table table-striped gp-table gp-table-fixed">
        <colgroup>
          <col class="w-sm"><!-- INSTANCE -->
          <col class="w"><!-- TYPE -->
          <col><!-- DETAILS -->
          <col><!-- REQUESTER -->
          <col><!-- SUBJECT -->
          <col class="w"><!-- STATUS -->
          <col class="w"><!-- ASSIGNEE -->
          <col class="w-sm"><!-- CREATION DATE -->
          <col class="w-sm"><!-- FINISH DATE -->
          <col class="w-sm"><!-- VALIDATION TYPE -->
          <col class="w-50"><!-- ACTIONS -->
        </colgroup>
        <thead class="workflow-table">
        <tr role="heading">
          <th class="text-uppercase va-baseline" gp-table-column scope="col"
              test-id="instance-header">{{ 'WORKFLOWS.instance' | translate }}</th>
          <th class="text-uppercase va-baseline" gp-table-column scope="col"
              test-id="type-header">{{ 'WORKFLOWS.type' | translate }}</th>
          <th class="text-uppercase va-baseline" gp-table-column scope="col"
              test-id="details-header">{{ 'WORKFLOWS.details' | translate }}</th>
          <th class="text-uppercase va-baseline" gp-table-column scope="col"
              test-id="requester-header">{{ 'WORKFLOWS.requester' | translate }}</th>
          <th class="text-uppercase va-baseline" gp-table-column scope="col"
              test-id="subject-header">{{ 'WORKFLOWS.subject' | translate }}</th>
          <th class="text-uppercase min-width-sm va-baseline" gp-table-column scope="col"
              test-id="status-header">{{ 'WORKFLOWS.status' | translate }}</th>
          <th class="text-uppercase va-baseline" gp-table-column scope="col"
              test-id="assignee-header">{{ 'WORKFLOWS.assignee' | translate }}</th>
          <th class="text-uppercase min-width-xs va-baseline" gp-table-column scope="col"
              test-id="creationDate-header">{{ 'WORKFLOWS.creationDate' | translate }}</th>
          <th class="text-uppercase min-width-xs va-baseline" gp-table-column scope="col"
              test-id="finishDate-header">{{ 'WORKFLOWS.finishDate' | translate }}</th>
          <th class="text-uppercase min-width-sm va-baseline" gp-table-column scope="col"
              test-id="validationType-header">{{ 'WORKFLOWS.validationType' | translate }}</th>
          <th class="va-baseline" scope="col"><!-- ACTIONS --></th>
        </tr>
        <tr role="heading">
          <td><!-- INSTANCE --></td>
          <td>
            <ng-select [attr.test-id]="'type-filter'"
                       [idField]="'key'"
                       [textField]="'key'"
                       [items]="workflowTypes"
                       [placeholder]="'WORKFLOWS.type' | translate "
                       class="form-control"
                       formControlName="type"
                       ngDefaultControl
            >
            </ng-select>
          </td>
          <td><!-- DETAILS --></td>
          <td>
            <input [attr.test-id]="'requester-filter'"
                   [attr.readOnly]="isLimitExceeded ? 'true' : null"
                   class="form-control"
                   formControlName="requester"
                   placeholder="{{'WORKFLOWS.requester' | translate}}"
                   type="text">
          </td>
          <td>
            <input [attr.test-id]="'subject-filter'"
                   [attr.readOnly]="isLimitExceeded ? 'true' : null"
                   class="form-control"
                   formControlName="subject"
                   placeholder="{{'WORKFLOWS.subject' | translate}}"
                   type="text">
          </td>
          <td>
            <ng-select [attr.test-id]="'status-filter'"
                       [idField]="'key'"
                       [textField]="'name'"
                       [items]="WORKFLOW_STATUS"
                       [placeholder]="'WORKFLOWS.status' | translate "
                       class="form-control "
                       formControlName="status"
                       ngDefaultControl
            >
            </ng-select>
          </td>
          <td>
            <input [attr.test-id]="'assignee-filter'"
                   [attr.readOnly]="isLimitExceeded ? 'true' : null"
                   class="form-control"
                   formControlName="assignee"
                   placeholder="{{'WORKFLOWS.assignee' | translate}}"
                   type="text">
          </td>
          <td class="vertical-align-middle">
            <label class="checkbox m-b-0">
              <input type="checkbox"
                     formControlName="createdBeyondMonth">
              <span class="m-l-xs">{{'PROCESS_MONITOR.one_month_older' | translate}}</span>
            </label>
          </td>
          <td><!-- FINISH DATE --></td>
          <td><!-- VALIDATION TYPE --></td>
          <td><!-- ACTIONS --></td>
        </tr>
        </thead>
        <tbody class="fade-in-right">
        <tr *ngIf="loading">
          <td class="text-center p-t-lg p-b-lg" colspan="11">
            <em class="fa fa-light fa-spinner fa-spin"></em>
          </td>
        </tr>
        <tr *ngIf="!loading && !requests?.length">
          <td *ngIf="!isLimitExceeded else limitExceededTemplate" class="text-center p-t-lg p-b-lg" colspan="11"
              test-id="not-found-message">
            {{ 'PROCESS_MONITOR.processes_not_found' | translate }}
          </td>
          <ng-template #limitExceededTemplate test-id="limit exceeded">
            <td class="limit-exceeded text-center p-t-lg p-b-lg" colspan="11">
              <gp-illustrated-message
                [text]="'COMMON.limit_exceeded'"
                [type]="'SOMETHING_WRONG'">
              </gp-illustrated-message>
            </td>
          </ng-template>

        </tr>
        <ng-container *ngIf="!loading && requests?.length">
          <tr (click)="onClickRequest(request, $event)"
              *ngFor="let request of requests"
              [class.selected]="selectedRequest && selectedRequest.id === request.id"
              class="pointer"
          >
            <td>
              <div class="flex">
                <span test-id="instance-id">{{request?.instanceShortId}}...</span>
                <em (click)="copyRequestId($event, request.id)"
                    *ngIf="!isCopied"
                    class="fa fa-light fa-copy pointer"
                    test-id="copy-tooltip"
                    tooltip="{{'WORKFLOWS.copy_request_id' | translate}}"></em>
                <em (mouseout)="toggleTooltip($event,false)"
                    *ngIf="isCopied"
                    [delay]="200"
                    class="fa fa-light fa-copy pointer"
                    test-id="'copy-tooltip"
                    tooltip="{{'WORKFLOWS.copied' | translate}}"></em>
              </div>
            </td>
            <td test-id="request-type">{{request?.type | translate}}</td>
            <td test-id="request-details">{{request.details ? (request.details | translate) : '-'}}</td>
            <td>
              <div>
                <span [attr.test-id]="'requester-full-name'">{{request?.requester?.fullName}}</span>
                <span *ngIf="request?.requester?.employeeNumber" [attr.test-id]="'requester-employee-number'"
                      class="text-muted">&nbsp;({{request?.requester?.employeeNumber}})</span>
              </div>
            </td>
            <td>
              <div>
                <span
                  [attr.test-id]="'subject-full-name'">{{request?.subject?.fullName ? request?.subject?.fullName : '-'}}</span>
                <span *ngIf="request?.subject?.employeeNumber"
                      [attr.test-id]="'subject-employee-number'"
                      class="text-muted">&nbsp;({{request?.subject?.employeeNumber}})</span>
              </div>
            </td>
            <td>
              <gp-workflow-status [status]="request.status"></gp-workflow-status>
            </td>
            <td>
              <ng-container *ngIf="request?.assignee else noAssignee">
                <div>
                  <span [attr.test-id]="'assignee-full-name'">{{request?.assignee?.fullName}}</span>
                  <span *ngIf="request?.assignee?.employeeNumber"
                        [attr.test-id]="'assignee-employee-number'"
                        class="text-muted">&nbsp;({{request?.assignee?.employeeNumber}})</span>
                </div>
              </ng-container>
              <ng-template #noAssignee>
                <ng-container *ngIf="request?.candidates?.length else noCandidates">
                  <div *ngFor="let candidate of request?.candidates; let index = index">
                    <span [attr.test-id]="'candidate-' + index + '-full-name'">{{candidate?.fullName}}</span>
                    <span *ngIf="candidate?.employeeNumber"
                          [attr.test-id]="'candidate-' + index + '-employee-number'"
                          class="text-muted">&nbsp;({{candidate?.employeeNumber}})</span>
                  </div>
                </ng-container>
              </ng-template>
              <ng-template #noCandidates>
                <div>-</div>
              </ng-template>
            </td>
            <td test-id="request-start-time">{{request?.startTime | gpDate: {withHour: true}: (trigger$|async)}}</td>
            <td test-id="request-end-time">{{request?.endTime | gpDate: {withHour: true}: (trigger$|async)}}</td>
            <td test-id="request-validation-type">
              <ng-container [ngSwitch]="request?.validationType">
                <span *ngSwitchCase="'NO_VALIDATION'">{{'WORKFLOWS.no_validation' | translate}}</span>
                <span *ngSwitchCase="'ONE_STEP_VALIDATION'">{{'WORKFLOWS.one_step_validation' | translate}}</span>
                <span *ngSwitchCase="'TWO_STEP_VALIDATION'">{{'WORKFLOWS.two_step_validation' | translate}}</span>
                <span *ngSwitchCase="'MULTI_STEP_VALIDATION'">{{'WORKFLOWS.multi_step_validation' | translate}}</span>
                <span *ngSwitchDefault>-</span>
              </ng-container>
            </td>
            <td *ngIf="{ opened: false } as contextMenu">
              <div (click-outside)="contextMenu.opened = false"
                   [class.open]="contextMenu.opened"
                   *ngIf="(request.isReassignable && isWorkflowAdmin) || request.cancellable"
                   class="dropdown">
                <button (click)="contextMenu.opened = !contextMenu.opened"
                        class="btn btn-outline btn-xs btn-context-menu"
                        type="button">
                  <span class="fa fa-light fa-ellipsis-v"></span>
                </button>
                <ul #rowActionContextMenu
                    (click)="contextMenu.opened = false"
                    *ngIf="contextMenu.opened"
                    class="dropdown-menu pull-right dropdown-menu-scale">
                  <li *ngIf="request.isReassignable && isWorkflowAdmin"
                      (click)="openReassignRequestModal(request)" class="dropdown-item">
                    <i aria-hidden="true"></i>
                    <span>{{ 'WORKFLOWS.reassign' | translate }}</span>
                  </li>
                  <li *ngIf="request.cancellable"
                      (click)="openCancelWorkflowModal(request, $event, contextMenu)" class="dropdown-item pointer">
                    <i aria-hidden="true"></i>
                    <span>{{ 'EMPLOYEE_FORM.cancel' | translate }}</span>
                  </li>
                </ul>
              </div>
            </td>

          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
    <footer class="dker p-a" gp-sticky="bottom">
      <div class="row">
        <div class="col-sm-12 text-center">
          <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
            <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
              <a (click)="pagination.hasPrevious() && pagination.first()" class="page-link">
                <em class="fa fa-light fa-angle-double-left"></em></a>
            </li>
            <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
              <a (click)="pagination.hasPrevious() && pagination.previous()" class="page-link">
                <em class="fa fa-light fa-angle-left"></em></a>
            </li>
            <li *ngFor="let page of pagination.pages()" class="page-item"
                [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
              <a *ngIf="page > 0" (click)="pagination.goToPage(page - 1)" class="page-link">{{ page }}</a>
              <a *ngIf="page < 1" class="page-link default-cursor">…</a>
            </li>
            <li [ngClass]="{disabled: !pagination.hasNext()}" class="page-item">
              <a (click)="pagination.hasNext() && pagination.next()" class="page-link">
                <em class="fa fa-light fa-angle-right"></em></a>
            </li>
            <li [ngClass]="{disabled: !pagination.hasNext()}" class="page-item">
              <a (click)="pagination.hasNext() && pagination.last()" class="page-link">
                <em class="fa fa-light fa-angle-double-right"></em></a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
  <gp-side-panel
    [isSidePanelOpen]="!!selectedRequest"
    (isSidePanelOpenChange)="closeSidePanel($event)"
    [sidePanelTitle]="('PROCESS_MONITOR.process_detail' | translate)">
    <div class="box-body m-t-sm w-100">
      <div class="flex flex-between">
        <div class="row-flex">
          <strong test-id="workflow-details-status-label">{{ 'WORKFLOWS.status' | translate }}:&nbsp;</strong>
          <gp-workflow-status
            test-id="workflow-details-status-value"
            [status]="selectedRequest?.status"></gp-workflow-status>
        </div>
        <div class="row-flex">
          <strong test-id="workflow-details-creation-date-label">{{ 'CHARTS.PAYROLL.created' | translate }}
            :&nbsp;</strong>
          <div
            test-id="workflow-details-creation-date-value">{{ selectedRequest?.startTime | gpDate: {withHour: true}: (trigger$|async) }}</div>
        </div>
      </div>
      <div class="m-t-xs" *ngIf="selectedRequest?.statusDetails">
        <gp-message [text]="selectedRequest?.statusDetails" type="danger"></gp-message>
      </div>
      <div class="m-t-md">
        <strong test-id="workflow-details-description-label">{{ 'WORKFLOWS.description' | translate }}:&nbsp;</strong>
        <div test-id="workflow-details-description-value" class="b-a p-a-sm m-t-sm white">
          {{ (selectedRequest?.descriptionTranslationKey) | translate | translateAndFormatVariables: selectedRequest?.variables: (trigger$|async) }}
        </div>
      </div>
      <div class="m-t-md">
        <strong>{{ 'WORKFLOWS.timeline' | translate }}:&nbsp;</strong>
        <gp-workflow-timeline [request]="selectedRequest"></gp-workflow-timeline>
      </div>
    </div>
  </gp-side-panel>
</div>

<gp-cancel-workflow-modal
  [cancelWorkflowDetails]="cancelWorkflowDetails"
  (onCancelWorkflow)="cancelWorkflow($event)">
</gp-cancel-workflow-modal>
